// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uNvA","right":"styles_right__2lVPr"};